import { forwardRef } from 'react';
import { cn } from '../utils/cn';

export type AvatarSize = 'sm' | 'md' | 'lg' | 'xl';

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  src?: string;
  alt?: string;
  initials?: string;
  size?: AvatarSize;
}

const sizeMap: Record<AvatarSize, string> = {
  sm: 'w-8 h-8 text-[12px]',
  md: 'w-10 h-10 text-[14px]',
  lg: 'w-12 h-12 text-[18px]',
  xl: 'w-16 h-16 text-[22px]',
};

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>(
  ({ className, src, alt, initials, size = 'md', ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden',
        'bg-gradient-to-br from-saffron-100 to-saffron-200 text-saffron-700',
        'font-display font-bold',
        sizeMap[size],
        className
      )}
      {...props}
    >
      {src ? (
        <img src={src} alt={alt ?? ''} className="w-full h-full object-cover" />
      ) : (
        initials
      )}
    </div>
  )
);
Avatar.displayName = 'Avatar';
